export default function(fileUrl, user) {
  const link = document.createElement('a')

  const url = `${fileUrl}&authorizationCode=${user.blobAccessAuthorizationCode}`

  document.body.appendChild(link)
  link.href = url
  link.click()
}
